import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';
const GetLocations = {
  name: 'getLocations',
  state: {
    data: [],
    allRecords:[],
    loading: false,
    error: '',
    totalCount: 0,
    tableHeader: [
      'Location',
      'Address',
      'Displays'
    ],
    rpp: 10,
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        data: [],
        totalCount: 0,
      };
    },

    getReceived(state, payload) {
      // eslint-disable-next-line array-callback-return
    const locationData = payload.data.map(item => ({
        id: item.id,
        location_name: item.location_name,
        address: item.address,
        displays:item.displays
      }));
      return {
        ...state,
        data: locationData,
        loading: false,
        error: '',
        totalCount: payload.totalCount,
      };
    },

    getRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async getAll({ page, size, search, sorted_by, sort }) {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        let url = `savvy/locations?org_id=${userInfo.org_id}&page=${page}&size=${size}`;
        if (search) {
          if (
            search.toLowerCase() === 'inactive' ||
            search.toLowerCase() === 'active'
          ) {
            url =
              url + `&active=${search.toLowerCase() === 'inactive' ? 0 : 1}`;
          } else {
            url = url + `&search=${encodeURIComponent(search)}`;
          }
        }
        if (sorted_by) {
          url = url + `&sorted_by=${sorted_by}`;
        }
        if (sort) {
          url = url + `&sort=${sort}`;
        }
        const response = await http.get(url);
        this.getReceived({
          data: response.data.data.rows,
          totalCount: response.data.data.count,
        });
        
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default GetLocations;